import { Box, Stack, TextField, Typography } from "@mui/material";
import { textFieldSx } from "../styles";

function BasicDetailsStep({ form, updateField }) {
  return (
    <Stack spacing={3} sx={{ maxWidth: 560 }}>
      <Typography sx={{ fontSize: 14, color: "rgba(255,255,255,0.6)" }}>
        Enter the basic information for this activation.
      </Typography>
      <Box>
        <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1 }}>Activation Name</Typography>
        <TextField
          fullWidth
          placeholder="Enter activation name"
          value={form.name}
          onChange={(e) => updateField("name", e.target.value)}
          sx={textFieldSx}
        />
      </Box>
      <Box>
        <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1 }}>Description</Typography>
        <TextField
          fullWidth
          multiline
          minRows={4}
          placeholder="Describe what this activation is about"
          value={form.description}
          onChange={(e) => updateField("description", e.target.value)}
          sx={textFieldSx}
        />
      </Box>
    </Stack>
  );
}

export default BasicDetailsStep;